import React from "react"
import { Box, Typography } from "@mui/material"
import { useNavigate, useParams } from "react-router-dom"

import {
  ContentContainer,
  Amount,
  SourceDescription,
  CenterContainer,
  RecipientContainer,
  ContinueButton,
  ButtonTransfer,
} from "./styled"
import IconBox from "../../../components/IconBox"
import UIIcon from "../../../components/UIIcon"
import { useGetSbpIncomeTransferRequest } from "../../../api/hooks/useGetSbpIncomeTransferRequest"
import LoadingOverlay from "../../../components/LoadingOverlay"
import SBPIconNoExt from "../../../components/SBPIconNoExt"

const PushTransferConfirm = () => {
  const { incomeTransferRequestId } = useParams()
  const { data, isLoading } = useGetSbpIncomeTransferRequest(incomeTransferRequestId)
  const navigate = useNavigate()
  const handleClickBack = () => {
    navigate("/")
  }

  if (isLoading) {
    return <LoadingOverlay />
  }

  return (
    <ContentContainer>
      <CenterContainer>
        <IconBox size="lg" color="yellow">
          <UIIcon iconName="checkYellow" size={80} />
        </IconBox>
        <SourceDescription variant="h3">Перевод выполнен</SourceDescription>
        <Amount variant="h1">{data?.amount} ₽</Amount>
        <RecipientContainer>
          <Typography variant="h4">
            Себе в {data?.bankInfo.title} через СБП
          </Typography>
        </RecipientContainer>
      </CenterContainer>
      <Box sx={ButtonTransfer}>
        <SBPIconNoExt size={60} />
        <ContinueButton variant="contained" fullWidth onClick={handleClickBack}>
          Готово
        </ContinueButton>
      </Box>
    </ContentContainer>
  )
}

export default PushTransferConfirm
